import { useEffect, useState } from 'react';
import { ComponentConfig } from '@measured/puck';
import { ColorProps, colorField } from '../../puck/reusable-props/color';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import { PaddingProps, paddingFields } from '../../puck/reusable-props/padding';
import { ReduxSelectorProps } from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import { Switch, Tooltip } from '@mui/material';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import InfoIcon from '@mui/icons-material/Info';
import Border, { IBorderValueProps } from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type AlwaysVipProps = {
  Button: CustomizeProps;
  Description: string;
  border: IBorderValueProps;
  defaultExpand: boolean;
  background: {
    color: string;
    isInherit: boolean;
  };
} & ColorProps &
  showComponentProps &
  MarginProps &
  PaddingProps;

export const AlwaysVip = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<AlwaysVipProps> => {
  return {
    label: (
      <CustomTooltip title="AlwaysVip">
        <span>Always VIP</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      Button: {
        type: 'custom',
        label: 'Button Name',
        render: ({ value, onChange, field }) => (
          <TextCustomInput
            value={value}
            onChange={onChange}
            title={field?.label}
          />
        ),
      },
      Description: {
        ...QuillTextEditor('Description').content,
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
      defaultExpand: {
        type: 'custom',
        label: 'Default Collapse',
        render: ({ value, onChange }) => {
          return (
            <div className="flex justify-between items-center mb-3">
              <p className="text-sm font-semibold">Default expand</p>
              <div className="flex gap-0.5 items-center">
                <Tooltip
                  title={
                    'Toggling this will either collapse or expand the Extra Terms by default.'
                  }
                  placement="top-start">
                  <InfoIcon fontSize="small" className="h-1 w-1" />
                </Tooltip>
                <Switch
                  checked={value}
                  onChange={event => onChange(event.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>
            </div>
          );
        },
      },

      ...colorField,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      border: {
        deviceType: 'desktop',
        borderBottomLeft: {
          desktop: '10',
          tablet: '8',
          mobile: '8',
        },
        borderBottomRight: {
          desktop: '10',
          tablet: '8',
          mobile: '8',
        },
        borderTopLeft: {
          desktop: '10',
          tablet: '8',
          mobile: '8',
        },
        borderTopRight: {
          desktop: '10',
          tablet: '8',
          mobile: '8',
        },
        borderWidth: {
          desktop: 1,
          tablet: 1,
          mobile: 1,
        },
        borderStyle: {
          desktop: 'border-solid',
          tablet: 'border-solid',
          mobile: 'border-solid',
        },
        borderColor: {
          desktop: '#000000',
          tablet: '#000000',
          mobile: '#000000',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      Button: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        deviceType: 'desktop',
        text: 'VIP Club®',
        textColor: {
          mobile: '#FFFFFF',
          tablet: '#FFFFFF',
          desktop: '#FFFFFF',
        },
        hoverColor: {
          mobile: '#F5F5F5',
          tablet: '#F5F5F5',
          desktop: '#F5F5F5',
        },
        fontSize: {
          mobile: 'text-2xl',
          tablet: 'text-2xl',
          desktop: 'text-2xl',
        },
      },

      defaultExpand: false,
      Description:
        '<p style="line-height:1.5;"><span style="font-size: 16px;">Lorem ipsum dolor sit amet, consectetur adipicing elit. Vivamus lacinia odio vitae vestibulum. Phasellus euismod vehicula augue, non tincidunt arcu auctor sed. Nulla facilisi. In ac interdum arcu, ac egestas sem. Integer cursus dui a orci cursus, non porttitor urna ultricies. Sed imperdiet justo id tortor tempus, eu laoreet tortor dapibus. Nunc vitae eros dolor. Mauris convallis dui sit amet justo dictum, non vulputate eros aliquam. Donec a orci vel ante posuere tincidunt.</span></p>',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      color: {
        backgroundColor: '#000000',
        hoverColor: '#000000',
      },
    },
    render: ({
      margin,
      color,
      padding,
      showComponent,
      Button,
      Description,
      defaultExpand,
      background,
      border,
      editMode,
    }) => {
      const [isExpanded, setIsExpanded] = useState<boolean>(false);
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const state = useAppSelector(state => state);
      const newInterpolation = getQuillEditorText(Description, state);
      const newButtonText = getQuillEditorText(Button?.text, state);
      useEffect(() => {
        setIsExpanded(defaultExpand);
      }, [defaultExpand]);

      const marginStyles = getMarginStyles(margin, currentDeviceType);

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getBorderProps(border, currentDeviceType),
                ...getPaddingStyles(padding, currentDeviceType),
              }}
              className={` ${border?.borderStyle?.[currentDeviceType]}`}>
              <div className="relative text-editor-content text-gray-900 rounded-lg overflow-hidden">
                <div
                  className={`py-4 text-center ${Button.fontSize?.[currentDeviceType]} ${Button.weight?.[currentDeviceType]}`}
                  style={{
                    backgroundColor: color?.backgroundColor,
                    color: Button.textColor?.[currentDeviceType],
                  }}
                  onMouseOver={e =>
                    (e.currentTarget.style.backgroundColor = color?.hoverColor)
                  }
                  onMouseOut={e =>
                    (e.currentTarget.style.backgroundColor =
                      color?.backgroundColor)
                  }
                  onClick={() => setIsExpanded(!isExpanded)}
                  role="button"
                  tabIndex={0}>
                  {newButtonText}
                </div>
                <div
                  className={`px-3 checkbox-text !bg-none text-left text-black  ease-in-out overflow-hidden ${isExpanded ? 'max-h-screen py-3' : 'max-h-0'}`}
                  style={{
                    backgroundColor: background?.isInherit
                      ? 'inherit'
                      : background?.color,
                    lineHeight: 1.5,
                  }}
                  dangerouslySetInnerHTML={{ __html: newInterpolation }}
                />
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
